module.exports = __webpack_public_path__ + "img/image_why04.edfe5f13.png";